import FavoriteCollectionService from '../../services/FavoriteCollectionService';
import favoriteCollectionUseCase from './favoriteCollectionUseCase';

const favoriteCollectionFactory = favoriteCollectionUseCase({
  FavoriteCollectionService: FavoriteCollectionService(),
});

export default favoriteCollectionFactory;
